var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	42953: () => (loadSingletonVersion("default", "rxjs", false, [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 71093))))))),
	68613: () => (loadSingletonVersion("default", "rxjs/operators", false, [,[1,7,0,0],[1,6,5,3],1], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 79011))))))),
	58819: () => (loadSingletonVersion("default", "@angular/core", false, [4,12,2,17], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	81984: () => (loadSingletonVersion("default", "@angular/core", false, [1,12,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	38446: () => (loadSingletonVersion("default", "rxjs", false, [2,6,6,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 71093))))))),
	52978: () => (loadSingletonVersion("default", "rxjs/operators", false, [2,6,6,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 79011))))))),
	64406: () => (loadSingletonVersion("default", "@angular/router", false, [1,12,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(8819), __webpack_require__.e(1121), __webpack_require__.e(4239)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 24239))))))),
	37375: () => (loadSingletonVersion("default", "@ngrx/store", false, [4,12,5,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(5576)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 55576))))))),
	31121: () => (loadSingletonVersion("default", "@angular/common", false, [4,12,2,17], () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 83595))))))),
	28383: () => (loadSingletonVersion("default", "@ngrx/effects", false, [1,12,5,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8118)]).then(() => (() => (__webpack_require__(/*! @ngrx/effects */ 28118))))))),
	35036: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,12,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 70926))))))),
	37698: () => (loadSingletonVersion("default", "@angular/common", false, [1,12,0,0], () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 83595))))))),
	53947: () => (loadSingletonVersion("default", "@savvaslearning/lst-auth", false, [1,2,1,0], () => (Promise.all([__webpack_require__.e(9135), __webpack_require__.e(2567)]).then(() => (() => (__webpack_require__(/*! @savvaslearning/lst-auth */ 22567))))))),
	76748: () => (loadSingletonVersion("default", "@ngrx/store", false, [1,12,5,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(5576)]).then(() => (() => (__webpack_require__(/*! @ngrx/store */ 55576))))))),
	84898: () => (loadSingletonVersion("default", "@ngx-translate/core", false, [1,13,0,0], () => (__webpack_require__.e(6718).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 86718))))))),
	61169: () => (loadSingleton("default", "@angular/common", false, () => (__webpack_require__.e(3595).then(() => (() => (__webpack_require__(/*! @angular/common */ 83595))))))),
	1577: () => (loadSingletonVersion("default", "@angular/core", false, [0,10,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	50179: () => (loadSingletonVersion("default", "rxjs/operators", false, [0,6,5,3], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 79011))))))),
	93587: () => (loadSingletonVersion("default", "rxjs", false, [0,6,5,3], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 71093))))))),
	9135: () => (loadSingletonVersion("default", "@angular/core", false, [4,12,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	39599: () => (loadSingletonVersion("default", "@angular/common/http", false, [4,12,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(8819), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 70926))))))),
	65121: () => (loadSingletonVersion("default", "@angular/common", false, [4,12,0,0], () => (Promise.all([__webpack_require__.e(8819), __webpack_require__.e(3595)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 83595))))))),
	4108: () => (loadSingletonVersion("default", "rxjs/operators", false, [1,6,0,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(9011)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 79011))))))),
	13821: () => (loadSingletonVersion("default", "@angular/core", false, [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,1,0],1,1,1,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(8613), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	73012: () => (loadSingletonVersion("default", "rxjs", false, [1,6,0,0], () => (Promise.all([__webpack_require__.e(4556), __webpack_require__.e(1093)]).then(() => (() => (__webpack_require__(/*! rxjs */ 71093))))))),
	91501: () => (loadSingletonVersion("default", "apollo-client", false, [1,2,3,4], () => (Promise.all([__webpack_require__.e(1380), __webpack_require__.e(4289)]).then(() => (() => (__webpack_require__(/*! apollo-client */ 64289))))))),
	24202: () => (loadSingletonVersion("default", "@angular/common/http", false, [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,0,0],1,1,1,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(926)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 70926))))))),
	25264: () => (loadSingletonVersion("default", "apollo-angular", false, [1,1,9,0], () => (__webpack_require__.e(3086).then(() => (() => (__webpack_require__(/*! apollo-angular */ 93086))))))),
	43218: () => (loadSingletonVersion("default", "@angular/core", false, [,[1,10,0,0],[1,9,0,0],[1,8,0,0],[1,7,0,0],[1,6,0,0],1,1,1,1], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435))))))),
	63686: () => (loadSingletonVersion("default", "@angular/core", false, [0,8,0,0], () => (Promise.all([__webpack_require__.e(2953), __webpack_require__.e(2435)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 32435)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"4": [
		38446,
		52978,
		64406
	],
	"926": [
		61169
	],
	"1121": [
		31121
	],
	"1613": [
		28383,
		35036,
		37698,
		53947,
		76748,
		84898
	],
	"1984": [
		81984
	],
	"1987": [
		24202,
		25264,
		43218,
		63686
	],
	"2567": [
		39599,
		65121
	],
	"2953": [
		42953
	],
	"3086": [
		4108,
		13821,
		73012,
		91501
	],
	"6718": [
		1577,
		50179,
		93587
	],
	"7375": [
		37375
	],
	"8613": [
		68613
	],
	"8819": [
		58819
	],
	"9135": [
		9135
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}